<template>
  <footer data-testid="checkout-layout-footer" :class="props.appendClass">
    <div class="bg-primary">
      <div class="mx-auto max-w-screen-xl">
        <TsRow
          no-gutter
          append-class="flex-col items-center text-idle-white pb-6 md:py-2.5 md:justify-between md:flex-row"
        >
          <TsColumn class="is-12 md:is-7">
            <div class="flex max-md:flex-col md:space-x-4 items-center">
              <div class="max-md:bg-primary max-md:w-full max-md:py-8 shrink-0">
                <NuxtLinkWithLocale
                  to="/"
                  data-testid="checkout-layout-footer-home-link"
                  class="max-w-max block mx-auto"
                >
                  <TsImage
                    src="/images/logos/toolstation-logo-halo.svg"
                    alt="logo"
                    data-testid="checkout-layout-footer-toolstation-logo"
                    height="54"
                    width="223"
                    class="max-md:mx-auto max-md:max-w-max"
                    loading="lazy"
                  />
                </NuxtLinkWithLocale>
              </div>
              <TsTypography
                :align="isMobile ? 'center' : 'left'"
                append-class="md:mr-4 max-md:pt-6 max-md:px-4 max-md:pb-2 leading-relaxed text-idle-white mb-0"
              > 
                <TsTypography
                  v-if="config.public.appRegion === 'NL'"
                  append-class="leading-relaxed text-idle-white mb-0"
                >
                  © {{ useTranslation("copyright", "Copyright") }}
                  <NuxtLinkWithLocale 
                    to="/" 
                    data-testid="checkout-layout-footer-home-link-text"
                  >
                    Toolstation
                  </NuxtLinkWithLocale>
                  {{ currentYear }}.
                  <br v-if="isMobile"/>
                  {{ useTranslation("chamberOfCommerce", "KvK-nummer:") }}
                  63449595<br />{{ useTranslation("vatNumber", "Btw-nummer:") }}
                  NL8552.40.854.B01
                  <br />
                  <span
                    >{{ useTranslation("version", "version") }}:
                    <small class="cursor-pointer underline hover:no-underline">{{
                      config.public.version
                    }}</small>
                  </span>
                </TsTypography>
                <TsTypography
                  :align="isMobile ? 'center' : 'left'"
                  v-else-if="config.public.appRegion === 'BE'"
                  append-class="leading-relaxed text-idle-white text-center md:text-left mb-0"
                >
                  Toolstation NV | Boomsesteenweg 58A, Aartselaar, België
                  BE0663.816.728 | 071 581 50 50 | 
                  <span class="underline cursor-pointer">
                    <a href="mailto:info@toolstation.be">info@toolstation.be</a>
                  </span>
                  <br v-if="!isMobile"/> | {{ useTranslation("version", "version") }}:
                  <small class="cursor-pointer underline hover:no-underline">
                    {{config.public.version}}
                  </small>
                </TsTypography>
              </TsTypography>
            </div>
          </TsColumn>
          <TsColumn class="is-12 md:is-5">   
            <ul
              class="relative flex flex-wrap md:justify-end justify-center items-center shrink-0"
            >
              <li class="flex px-4 max-md:border-r-2">
                <NuxtLinkWithLocale
                  :to="getContentSlug('privacy')"
                  data-testid="checkout-layout-footer-privacy-policy-link"
                >
                  <TsTypography
                    align="center"
                    append-class="text-idle-white mb-0"
                  >
                    {{useTranslation('privacyPolicy', 'Privacybeleid')}}
                  </TsTypography>
                </NuxtLinkWithLocale>
              </li>
              <li class="flex px-4 sm:max-md:border-r-2">
                <NuxtLinkWithLocale
                  :to="getContentSlug('cookies')"
                  data-testid="checkout-layout-footer-cookie-policy-link"
                >
                  <TsTypography append-class="text-idle-white mb-0">
                    {{useTranslation('cookiePolicy', 'Cookiebeleid')}}
                  </TsTypography>
                </NuxtLinkWithLocale>
              </li>
            </ul>
          </TsColumn>
        </TsRow>
      </div>
    </div>
  </footer> 
</template>
 
<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";
import { getContentSlug } from "~/utils/navigation";

const { isMobile } = useDevice();
const config = useRuntimeConfig();

const currentYear = new Date().getFullYear();

type Props = {
  dataTestid?: string;
  appendClass?: string;
};

const props = defineProps<Props>();
</script>